export default function is5xxError(code: number): boolean {
  return 500 <= code && code <= 599;
}
